module.exports = __webpack_public_path__ + "static/media/Notification.da582af2.svg";